import { useEffect, useState } from 'react';
import {
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { EFileType } from '../../../../../shared/library/Library';
import { LibraryFileDTO } from '../../../../../shared/library/LibraryDTO';
import { useGetLibraryFilesQuery } from '../../../../pages/library/lib/libraryRTKApi';
import { AppInput } from '../../../../shared/AppInput/AppInput';
import { DocumentLinkIcon } from '../../../DocumentLink/DocumentLinkIcon';

type Props = {
  // setMenuState: (state: MediaFieldMenuState) => void;
  onLibraryItemAdd: (item: LibraryFileDTO) => void;
};

const EmbedNodeMenuLibrary = ({
  // setMenuState,
  onLibraryItemAdd,
}: Props): JSX.Element => {
  const { data: files } = useGetLibraryFilesQuery({ types: [EFileType.LINK] });
  const [searchFilter, setSearchFilter] = useState('');
  const [rows, setRows] = useState<LibraryFileDTO[]>([]);

  useEffect(() => {
    let tempRows: LibraryFileDTO[] = files || [];

    if (searchFilter) {
      tempRows = tempRows.filter((x: Partial<LibraryFileDTO>) => (
        !!x.name && x.name.toUpperCase().indexOf(searchFilter.toUpperCase()) >= 0
      ));
    }

    setRows(tempRows);
  }, [searchFilter, files]);

  return (
    <>
      <Box
        sx={{
          width: '100%',
          padding: '5px 22px',
        }}
      >
        <AppInput
          placeholder="Search"
          defaultValue={searchFilter}
          type="text"
          value={searchFilter}
          onChange={(event) => {
            setSearchFilter(event.target.value);
          }}
          sx={{
            width: '100%',
          }}
        />
      </Box>
      <Box
        sx={{
          maxHeight: 300,
          overflowY: 'auto',
          marginBottom: '12px',
          padding: '0 4px',
        }}
      >
        <List>
          {
            rows.map((x: LibraryFileDTO) => (
              <ListItemButton
                onClick={() => {
                  onLibraryItemAdd(x);
                }}
                key={x.name}
              >
                <ListItemIcon>
                  <DocumentLinkIcon contentType={x.linkType} />
                </ListItemIcon>
                <ListItemText primary={x.name} />
              </ListItemButton>
            ))
          }
        </List>
      </Box>
    </>
  );
};

export default EmbedNodeMenuLibrary;
